/**
 * @description 预处理，自己实现页面的preload处理，方便控制loaderjs的方式
 *
 * 暂时无用
 *
 */
import JsLoader from "If_AdTool/common/JsLoader";
import getSctiptUrl from "../utils/getScriptUrl";
function preload(...args){
    let arr=[...args],data = arr.shift();
    if(data.hasOwnProperty("data")&&data.hasOwnProperty("preload")&&data.hasOwnProperty("callback")){
        JsLoader(getSctiptUrl(data.preload), () => {
            arr.unshift(data.data);
            IfengAmgr.tplLib[data.callback].render.apply(null,arr);
        });
    }
}
export default preload;